module.exports = __webpack_public_path__ + "img/icon_jobfair_1.a5d09796.png";